<template>
	<LabeledFieldLayout
		class="recurrence-day-picker-field"
	>
		<div class="days">
			<TeamingButton2
				v-for="dayOption in patchedDayOptions"
				:key="dayOption.value"
				:type="dayOption.isSelected ? `SECONDARY` : `TERTIARY`"
				:borderless="dayOption.isSelected"
				@click="onDaySelect( dayOption )"
			>
				<template #left-icon v-if="dayOption.isSelected">
					<FontAwesomeIcon :icon="[ `fas`, `check` ]" />
				</template>
				<template #default>{{ dayOption.text }}</template>
			</TeamingButton2>
		</div>
	</LabeledFieldLayout>
</template>

<script>

import {
	LabeledFieldLayout,
	TeamingButton2
} from "@teaming/common-ui";

export const makeOption = ( {
	text = "",
	value = "",
} = {} ) => ( {
	text,
	value,
} );

export default {
	name: "RecurrenceDayPickerField",
	teamingPackage: "common-team",
	emits: [ "select", ],
	components: {
		LabeledFieldLayout,
		TeamingButton2,
	},
	props: {
		value: {
			type: Array, // Array.<String>
			required: true,
		},
		dayOptions: {
			type: Array,
			required: true,
		},
		multiSelect: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		patchedDayOptions() {
			const { dayOptions, value, } = this;
			return dayOptions.map( option => ( {
				...option,
				isSelected: ( value.includes( option.value ) ),
			} ) );
		},
	},
	methods: {
		onDaySelect( { value: selectedValue, } ) {
			const { value, multiSelect, } = this;
			// remove the value
			if ( value.includes( selectedValue ) ) {
				return this.$emit( "select",
					multiSelect ?
						value.filter( v => v !== selectedValue ) :
						[]
				);
			}
			// add the value
			this.$emit( "select", [
				...( multiSelect ? value : [] ),
				selectedValue,
			] );
		},
	},
};
</script>

<style lang="scss" scoped>
.recurrence-day-picker-field .days {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	flex-wrap: wrap;
	gap: 0.5rem;
}
</style>
